import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {ProviderMappingsContext} from '../hooks/useProviderMappings';

// The /provider-mappings index, and also the "Billing Provider Mappings" tab on the
// product, customer and price profiles, which pass the id they are scoped to. The
// breadcrumbs belong to the standalone page only: inside a profile tab the profile's own
// navigation is already on screen.
export const IndexPage = ({productId, customerId, priceId}: ProviderMappingsContext) => {
    const embedded = !!(productId || customerId || priceId);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={embedded ? undefined : <IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable productId={productId} customerId={customerId} priceId={priceId}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
